<template>
  <div style="width:100%;">
    <table>
      <tr>
        <th></th>
        <th class="center">Beta Users</th>
        <th></th>
      </tr>
      <tr v-for="(user, index) in users" :key="user.id">
        <td>{{ index }}</td>
        <td @click="goUserDetail(user)">
          <i class="material-icons center">account_circle</i>
        </td>
        <td @click="goUserDetail(user)">
          <p>{{user.email}}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import services from "@/services/services";

export default {
  name: "beta-users",
  data() {
    return {
      users: []
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    goUserDetail(user) {
      this.$router.push({
        name: "admin-user-detail",
        params: { user: user, current_user: false }
      });
    },
    async getUsers() {
      const response = await services.getBetaUsers();
      this.users = response.data;
    },
    async deletePost(phone, idx) {
      const $this = this;
      $this
        .$swal({
          title: "Are you sure?",
          text: "You cannot undo this.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Delete"
        })
        .then(function(result) {
          if (result.value) {
            services.deleteBetaUser(phone);
            $this.users.splice(idx, 1);
          }
        });
    }
  }
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.center {
  display: flex;
  justify-content: center;
}
</style>
